export type LearningVisit = {
  id: string;
  lastSeen: number;
  source: string;
  path: string;
  locale: string;
};
const KEY = "abg.learning.visit.v1";
let fallback: LearningVisit | null = null;

export function readLearningVisit(): LearningVisit | null {
  let value = fallback;
  try {
    const raw = sessionStorage.getItem(KEY);
    if (raw) value = JSON.parse(raw) as LearningVisit;
  } catch {
    /* Session storage may be disabled. */
  }
  return value &&
    typeof value.id === "string" &&
    Date.now() - value.lastSeen < 30 * 60_000
    ? value
    : null;
}

function source(): string {
  try {
    if (!document.referrer) return "direct_unknown";
    const host = new URL(document.referrer).hostname;
    if (host === window.location.hostname) return "direct_unknown";
    if (/^(www\.)?google\.[a-z.]+$/.test(host)) return "google";
    if (host === "bing.com" || host.endsWith(".bing.com")) return "bing";
    if (host === "chatgpt.com" || host === "chat.openai.com") return "chatgpt";
    if (host === "perplexity.ai" || host.endsWith(".perplexity.ai"))
      return "perplexity";
    return "other_referral";
  } catch {
    return "direct_unknown";
  }
}

export function touchLearningVisit(
  path: string,
  locale: string,
): LearningVisit {
  const previous = readLearningVisit();
  const value = {
    id: previous?.id ?? crypto.randomUUID(),
    source: previous?.source ?? source(),
    path,
    locale,
    lastSeen: Date.now(),
  };
  fallback = value;
  try {
    sessionStorage.setItem(KEY, JSON.stringify(value));
  } catch {
    /* Keep this visit in memory. */
  }
  return value;
}

// Signup waits for pending page events so its server-side attribution has a
// persisted visit to associate with the newly created user.
export const pendingLearningEvents = new Set<Promise<unknown>>();
export async function flushLearningEvents(): Promise<void> {
  await Promise.allSettled([...pendingLearningEvents]);
}
